<template>
  <NuxtLoadingIndicator color="var(--primary-2)" />
  <Html :dir="head.htmlAttrs.dir">
    <LayoutTheHeader
      :route-path="routePath"
      @open-login="openLogin"
      :header-class="layout.headerClass"
    />
    <Auth ref="authRef">
      <template #googleSignin>
        <google />
      </template>
    </Auth>
    <main :class="isHome ? 'pt-[5.5rem]' : 'pt-[3.75rem]'">
      <slot />
    </main>
    <LazyHydrationWrapper :when-visible="{ rootMargin: '50px' }">
      <LazyLayoutTheFooterOneOne />
      <slot name="whats-app">
        <LazyLayoutWhatsappFloatButtonPicker :raised="isProductPage" />
      </slot>
    </LazyHydrationWrapper>
  </Html>
</template>

<script setup lang="ts">
import type { LayoutInfo } from "../types/templateConfiguration.d.ts";
import { provide, ref, watch } from "vue";
const runtimeConfig = useRuntimeConfig();
const layout = ref<MaybeRef>(runtimeConfig.public.layout as LayoutInfo);
const authRef = ref<any>(null);
function openLogin() {
  authRef.value.open();
}
provide("openLogin", openLogin);
const head = useI18nHead();

const localePath = useLocalePath();

const route = useRoute();
const routePath = ref(route.path);
const isProductPage = useIsProductPage();

const isHome = ref(true);

watch(
  () => route.path,
  () => {
    routePath.value = route.path;
    isHome.value = route.path == localePath("/");
  },
  { immediate: true }
);
</script>
